var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef } from 'react';
import { AppIcon } from '@backrs_ui/common-ui/src/designSystem/icons/AppIcon';
import { Menu, MenuItem, Typography, Box, Chip } from '@mui/material';
export function DoubleSelectDropdown(_a) {
    var id = _a.id, sections = _a.sections;
    var _b = useState({
        left: null,
        right: null,
    }), menuAnchors = _b[0], setMenuAnchors = _b[1];
    var buttonRefs = {
        left: useRef(null),
        right: useRef(null),
    };
    var openMenu = function (key) {
        setMenuAnchors(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = buttonRefs[key].current, _a)));
        });
    };
    var closeMenu = function (key) {
        setMenuAnchors(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = null, _a)));
        });
    };
    var leftSection = sections.find(function (s) { return s.key === 'left'; });
    var rightSection = sections.find(function (s) { return s.key === 'right'; });
    if (!leftSection || !rightSection) {
        return null;
    }
    return (_jsxs(Box, { id: id, sx: containerStyles, children: [_jsx(DropdownSection, { id: id ? "".concat(id, "-left") : undefined, value: leftSection.value, placeholder: leftSection.placeholder, options: leftSection.options, badgeCount: leftSection.badgeCount, onClick: function () { return openMenu('left'); }, buttonRef: buttonRefs.left, isLeft: true }), _jsx(Box, { sx: dividerStyles }), _jsx(Box, { sx: horizontalDividerStyles }), _jsx(DropdownSection, { id: id ? "".concat(id, "-right") : undefined, value: rightSection.value, placeholder: rightSection.placeholder, options: rightSection.options, badgeCount: rightSection.badgeCount, onClick: function () { return openMenu('right'); }, buttonRef: buttonRefs.right, isLeft: false }), _jsx(DropdownMenu, { id: id ? "".concat(id, "-left") : undefined, anchorEl: menuAnchors.left, isOpen: Boolean(menuAnchors.left), onClose: function () { return closeMenu('left'); }, options: leftSection.options, onOptionClick: function (value) {
                    leftSection.onChange(value);
                    closeMenu('left');
                }, anchorHorizontal: "left" }), _jsx(DropdownMenu, { id: id ? "".concat(id, "-right") : undefined, anchorEl: menuAnchors.right, isOpen: Boolean(menuAnchors.right), onClose: function () { return closeMenu('right'); }, options: rightSection.options, onOptionClick: function (value) {
                    rightSection.onChange(value);
                    closeMenu('right');
                }, anchorHorizontal: "right" })] }));
}
function DropdownSection(_a) {
    var id = _a.id, value = _a.value, placeholder = _a.placeholder, options = _a.options, _b = _a.badgeCount, badgeCount = _b === void 0 ? 0 : _b, onClick = _a.onClick, buttonRef = _a.buttonRef, isLeft = _a.isLeft;
    var getDisplayText = function () {
        var selectedOption = options.find(function (option) { return option.value === value; });
        return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || placeholder;
    };
    var displayText = getDisplayText();
    return (_jsx(Box, { id: id, ref: buttonRef, sx: isLeft ? leftSectionStyles : rightSectionStyles, onClick: onClick, children: _jsxs(Box, { sx: contentStyles, children: [_jsx(Typography, { variant: "text-sm-semibold", color: function (theme) { return theme.backrs.colors['Colors/Text/text-secondary']; }, sx: textTruncationStyles, children: displayText }), isLeft && badgeCount > 0 && (_jsx(Chip, { label: badgeCount, size: "small", variant: "badge", type: "leading", sx: chipSx, icon: _jsx(AppIcon, { iconName: "Circle", diameter: "8px", color: "Brand/700", fill: "Brand/700" }) })), _jsx(AppIcon, { iconName: "ChevronDown", diameter: "16px", color: "Colors/Text/text-primary" })] }) }));
}
function DropdownMenu(_a) {
    var id = _a.id, anchorEl = _a.anchorEl, isOpen = _a.isOpen, onClose = _a.onClose, options = _a.options, onOptionClick = _a.onOptionClick, anchorHorizontal = _a.anchorHorizontal;
    return (_jsx(Menu, { id: id ? "".concat(id, "-menu") : undefined, anchorEl: anchorEl, open: isOpen, onClose: onClose, slotProps: {
            paper: {
                sx: menuPaperStyles,
            },
        }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: anchorHorizontal,
        }, transformOrigin: {
            vertical: 'top',
            horizontal: anchorHorizontal,
        }, children: options.map(function (option) { return (_jsx(MenuItem, { id: id ? "".concat(id, "-option-").concat(option.value.toLowerCase().replace(/\s+/g, '-')) : undefined, onClick: function () { return onOptionClick(option.value); }, sx: menuItemStyles, children: _jsxs(Box, { sx: menuItemContentStyles, children: [_jsx(Typography, { variant: "text-sm-regular", children: option.label }), option.dotColor && (_jsx(AppIcon, { iconName: "Circle", diameter: "8px", color: option.dotColor || 'Brand/700', fill: option.dotColor || 'Brand/700' }))] }) }, option.value)); }) }));
}
var containerStyles = function (_a) {
    var backrs = _a.backrs;
    return ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        border: '1px solid',
        borderColor: backrs.colors['Colors/Foreground/fg-tertiary'],
        borderRadius: backrs.radius['radius-md'],
        backgroundColor: backrs.colors['Colors/Base/White'],
        overflow: 'hidden',
        width: {
            xs: '100%',
            sm: 'fit-content',
        },
        cursor: 'pointer',
        minHeight: '40px',
        transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
        '&:hover': {
            borderColor: backrs.colors['Colors/Foreground/fg-primary'],
            boxShadow: backrs.shadows['shadow-lg'],
        },
        flexGrow: 1,
        '@media (max-width: 350px)': {
            flexDirection: 'column',
        },
    });
};
var baseSectionStyles = function (_a) {
    var backrs = _a.backrs;
    return ({
        flex: 1,
        mx: backrs.spacing['spacing-md'],
        padding: {
            xs: backrs.spacing['spacing-md'],
            sm: 0,
        },
        '&:hover': {
            backgroundColor: backrs.colors['Gray/50'],
        },
        transition: 'all 0.3s ease-in-out',
        width: '100%',
        '@container (max-width: 450px)': {
            minWidth: 0,
            overflow: 'hidden',
        },
    });
};
var leftSectionStyles = function (theme) { return (__assign(__assign({}, baseSectionStyles(theme)), { borderTopLeftRadius: theme.backrs.radius['radius-lg'], borderBottomLeftRadius: 0, borderTopRightRadius: 0, borderBottomRightRadius: 0 })); };
var rightSectionStyles = function (theme) { return (__assign(__assign({}, baseSectionStyles(theme)), { borderTopRightRadius: 0, borderBottomRightRadius: theme.backrs.radius['radius-lg'], borderTopLeftRadius: 0, borderBottomLeftRadius: 0 })); };
var contentStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: '8px',
};
var textTruncationStyles = {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    flex: 1,
    minWidth: 0,
};
var dividerStyles = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '1px',
        minHeight: '38px',
        backgroundColor: backrs.colors['Gray/300'],
        alignSelf: 'center',
        display: 'block',
        '@media (max-width: 350px)': {
            display: 'none',
        },
    });
};
var horizontalDividerStyles = function (_a) {
    var backrs = _a.backrs;
    return ({
        width: '100%',
        height: '1px',
        backgroundColor: backrs.colors['Gray/300'],
        display: 'none',
        '@media (max-width: 350px)': {
            display: 'block',
        },
    });
};
var chipSx = function (_a) {
    var backrs = _a.backrs, typography = _a.typography;
    return ({
        backgroundColor: backrs.colors['Colors/Background/bg-primary'],
        boxShadow: backrs.shadows['shadow-xs'],
        border: "1px solid ".concat(backrs.colors['Colors/Border/border-primary']),
        borderRadius: backrs.radius['radius-sm'],
        padding: "".concat(backrs.spacing['spacing-xxs'], " ").concat(backrs.spacing['spacing-sm']),
        '& .MuiChip-label': __assign(__assign({}, typography['text-xs-medium']), { padding: "".concat(backrs.spacing['spacing-none'], " ").concat(backrs.spacing['spacing-xxs'], " ").concat(backrs.spacing['spacing-none'], " ").concat(backrs.spacing['spacing-xs']) }),
        '& .MuiChip-icon': {
            marginLeft: backrs.spacing['spacing-none'],
            marginRight: backrs.spacing['spacing-none'],
            display: 'flex',
            alignItems: 'baseline',
            justifyContent: 'center',
        },
    });
};
var menuPaperStyles = function (_a) {
    var backrs = _a.backrs;
    return ({
        mt: backrs.spacing['spacing-md'],
        boxShadow: backrs.shadows['shadow-xl'],
        border: "1px solid ".concat(backrs.colors['Colors/Foreground/fg-primary']),
        borderRadius: backrs.radius['radius-md'],
        minWidth: '200px',
        maxWidth: 'none',
    });
};
var menuItemStyles = function (_a) {
    var backrs = _a.backrs;
    return ({
        padding: "".concat(backrs.spacing['spacing-md'], " ").concat(backrs.spacing['spacing-lg']),
        '&.Mui-selected': {
            backgroundColor: backrs.colors['Brand/50'],
        },
        transition: 'all 0.3s ease-in-out',
        '&.MuiMenuItem-root': {
            '&:hover': {
                backgroundColor: "".concat(backrs.colors['Colors/Background/bg-active'], " !important"),
            },
        },
    });
};
var menuItemContentStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    gap: '8px',
    paddingRight: '4px',
};
